import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { timeValue } from 'app/constants';
import { appointmentRequestTrialStatus } from 'app/constants/csv/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { HTTPService, HelperService, ValidationService, DateService, DataService } from 'app/services';
import { environment } from 'environments/environment';
import { sortBy } from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-google-appointment-request',
  templateUrl: './google-appointment-request.component.html',
  styleUrls: ['./google-appointment-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GoogleAppointmentRequestComponent implements OnInit {
  @ViewChild('addVehicleForm', { static: true }) addVehicleForm: any;
  @ViewChildren('dayBox') dayBoxes!: QueryList<ElementRef>;
  @ViewChild('target') target!: ElementRef;

  focus: any = {};
  errors: any = {};
  formNotValid: boolean = false;
  query: any = {};
  activeView = 'week';
  isCustomerView = false;
  selectedDay = [];
  selectedTimeCategory = [];
  selectedTimeSlot = [];
  firstStepper = true;
  secondStepper = false;
  thirdStepper = false;
  fourthStepper = false;
  newDate = new Date();
  isSelectedService = false;
  isSaveState = false;
  minimumDate = new Date();
  timeSlot = [];
  days = [
    { id: 1, day: new Date() },
    { id: 2, day: new Date() },
    { id: 3, day: new Date() },
    { id: 4, day: new Date() },
    { id: 5, day: new Date() },
  ];
  time = [
    { id: 1, day: 'morning', name: 'Morning' },
    { id: 2, day: 'midDay', name: 'Mid-day' },
    { id: 3, day: 'evening', name: 'Evening' },
  ];
  showVehicleDropdown = false;
  showServiceDropdown = false;
  vehicleSearchPlaceholder = 'Search VIN, or year, make, model';
  vehicleSuggestions: any[] = [];
  vehicleType: any = { active: [], inactive: [] };
  vehicleQuery: string = '';
  isLoading: boolean = false;
  vehicle: any = {};
  userInfo: any = {};
  defaultRegStateCode: string = '';
  isVehicleNameUnique: boolean = true;
  isCreateVehicleMode: boolean = false;
  customer: any;
  apiResponse: any;
  searchType: any = '';
  selectVehicle: any = 'Select Vehicle';
  selectedService: any = [];
  showServiceName: any;
  dropOffs = ['I will wait with my vehicle', 'I will drop off my vehicle'];
  onDays = new Date();
  daysOfWeek = [];
  token = '';
  campaignId: string = '';
  campaign: any;
  company: any = {};
  companySetting: any = {};
  serviceCategories = [];
  defaultServiceCategories = [];
  startDate: any = new Date();
  endDate: any = new Date();
  availableDates = [];
  code = '';
  serviceText = '';
  confirmedDate: any = '';
  isDirty = false;
  isFirstTimeLoad = false;
  isApptRequestPortalEnabled = true;
  appointmentRequestTrialStatus = appointmentRequestTrialStatus;
  customerDetails = {
    isShopAddress: false,
    isVehicleDropOffVisible: false,
    isVehicleMandatory: false,
  };
  isCompanyLoading: boolean = true;
  googleConversionTrackingToken: string;
  companyLogo = '';
  primaryColor = '';
  bgColor = '';
  dayStart = 0;
  isOperationalNotifEnabled: boolean = true;
  isMarketingNotifEnabled: boolean = true;
  firstRequest: boolean = true;
  isVehicleSearchTriggered: boolean;
  serverTime: number = 0;
  isFindingActiveWeek = true;
  defaultStartDate: Date;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private route: ActivatedRoute,
    private validationEmailService: ValidationService,
    private dateService: DateService,
    private dataService: DataService
  ) { }

  async ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('appt_conf_token');
    this.campaignId = this.route.snapshot.queryParamMap.get('trackingId');
    this.googleConversionTrackingToken = this.route.snapshot.queryParamMap.get('rwg_token');

    const firstName = this.route.snapshot.queryParamMap.get('firstName');
    const lastName = this.route.snapshot.queryParamMap.get('lastName');
    const email = this.route.snapshot.queryParamMap.get('email');
    const phone = this.route.snapshot.queryParamMap.get('phone');

    if (firstName) this.userInfo.firstName = firstName;
    if (lastName) this.userInfo.lastName = lastName;
    if (email) this.userInfo.email = email;
    if (phone) this.userInfo.phone = phone;
    try {
      const data = this.helperService.jwtDecode(this.token);

      if (data?.companyId) {
        const site = await this.httpService.checkCompanySite(data.companyId);

        // if (environment.site && site && environment.site !== site) {
        //   window.location.replace(`${environment.app2_base_url}${window.location.hash}`);
        //   return;
        // }

        this.isCompanyLoading = false;

        await this.findAndLoadActiveWeek();
      }
    } catch (err) {
      console.log(err);
      this.isCompanyLoading = false;
    }
  }

  async getCustomerRequest() {
    let query: any = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    // if(this.dataService.isMarketingEnabled && this.dataService.isMarketingLeadAttributionEnabled){
    query.leadCampaignId = this.campaignId;
    // }
    let response = await this.httpService.getEndCustomerRequest(this.token, query);
    this.company = response.availableDates;
    this.companySetting = response.company;
    this.companySetting.phone = this.helperService.formatPhoneNumber(this.companySetting.phone);
    if (response.leadCampaign) {
      this.campaign = response.leadCampaign;
    }
    this.updateShopLevelColor(response);

    if (this.companySetting && this.companySetting.address && this.companySetting.address.addLine1) {
      this.companySetting.fullAddress = this.helperService.trimString(
        (this.companySetting.fullAddress = `
     ${this.companySetting.address.addLine1 || ''} ${this.companySetting.address.country || ''},
      ${this.companySetting.address.city || ''}, ${this.companySetting.address.stateCode || ''}`)
      );
    }

    if (response?.company?.appsettings?.apptRequestPortal?.apptProximityLimit) {
      this.dayStart = response.company.appsettings.apptRequestPortal.apptProximityLimit.value;
    }

    if (response.company.appsettings.apptRequestPortal.apptRequestCustomerDetails) {
      this.customerDetails = response.company.appsettings.apptRequestPortal.apptRequestCustomerDetails;
      if (this.customerDetails?.isVehicleMandatory) {
        this.vehicleSearchPlaceholder = 'Search VIN, or year, make, model*';
      }
    }

    this.company.map((day) => {
      let entries = Object.entries(day.officeHours);
      let checkCompanyHrs = false;
      if (day.isDayActive) {
        entries.map((entry: any) => {
          if (entry && entry[1].length > 0) {
            checkCompanyHrs = true;
          }
          if (!checkCompanyHrs) {
            day.isDayActive = false;
          } else day.isDayActive = true;
        });
      }
    });
    this.isApptRequestPortalEnabled = response.company.appsettings.isApptRequestPortalEnabled;

    if (response.trialStatus === appointmentRequestTrialStatus.expired) {
      this.isApptRequestPortalEnabled = false;
    }
    if (response.company.appsettings && response.company.appsettings.apptRequestPortal) {
      this.serviceCategories = [];
      if (response.company.appsettings.apptRequestPortal.serviceCategories) {
        response.company.appsettings.apptRequestPortal.serviceCategories.map((x) => {
          if (!x.isHidden) {
            let service = { name: x.name, isHidden: false, services: [] };
            if (x.services && x.services.length > 0) {
              x.services.map((y) => {
                if (!y.isHidden) {
                  service.services.push(y);
                }
              });
              this.serviceCategories.push(service);
            }
          }
        });
      }

      if (response.company.appsettings.apptRequestPortal.defaultServiceCategories) {
        response.company.appsettings.apptRequestPortal.defaultServiceCategories.map((x) => {
          if (!x.isHidden) {
            let service = { name: x.name, isHidden: false, services: [] };
            if (x.services && x.services.length > 0) {
              x.services.map((y) => {
                if (!y.isHidden) {
                  service.services.push(y);
                }
              });
              this.serviceCategories.push(service);
            }
          }
        });
      }
    }
    this.company && this.company.length > 0 ? this.checkDateAvailability() : null;
    !this.isDirty ? this.defaultSettings() : null;
  }

  onSelectVehicle() {
    this.showVehicleDropdown = !this.showVehicleDropdown;
  }

  onSelectService() {
    this.showServiceDropdown = !this.showServiceDropdown;
  }

  validation(): boolean {
    let isValid = true;
    if (!this.vehicle.year) {
      this.errors.year = 'Year required';
      isValid = false;
    }
    if (!this.vehicle.make) {
      this.errors.make = 'Make required';
      isValid = false;
    }
    if (!this.vehicle.model) {
      this.errors.model = 'Model required';
      isValid = false;
    }
    return isValid;
  }

  nameValidation(): boolean {
    let isValid = true;
    if (!this.userInfo.firstName) {
      this.errors.firstName = 'First Name required';
      isValid = false;
    } else this.errors.firstName = '';
    if (!this.userInfo.lastName) {
      this.errors.lastName = 'Last Name required';
      isValid = false;
    } else this.errors.lastName = '';
    if (!this.userInfo.phone) {
      this.errors.phone = 'Mobile number required';
      isValid = false;
    }
    if (this.userInfo.phone && this.userInfo.phone.replace(/\D/g, '').length < 10) {
      this.errors.phone = `Phone is not valid`;
      isValid = false;
    }
    if (this.userInfo.email && !this.validationEmailService.validateEmail(this.userInfo.email)) {
      this.errors.email = 'Email is not valid';
      isValid = false;
    }
    return isValid;
  }

  dayValidation(): boolean {
    let isValid = true;
    if (this.selectedDay.length === 0) {
      this.errors.selectDay = 'Day required';
      isValid = false;
    } else this.errors.selectDay = '';
    if (this.selectedTimeSlot.length === 0) {
      this.errors.selectTime = 'Time required';
      isValid = false;
    } else this.errors.selectTime = '';
    if (!this.userInfo.vehicleDropoff && this.customerDetails?.isVehicleDropOffVisible) {
      this.errors.dropOff = 'Drop-off required';
      isValid = false;
    } else this.errors.dropOff = '';
    return isValid;
  }

  onSaveVehicle() {
    if (!this.validation()) {
      return;
    } else {
      this.helperService.showToaster('success', 'Vehicle Updated');
      this.selectVehicle = `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}`;
      this.vehicle.title = this.selectVehicle;
      this.showVehicleDropdown = false;
      this.errors.selectVehicle = '';
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.addVehicleForm.nativeElement.scrollTop = this.addVehicleForm.nativeElement.scrollHeight + 18;
      } catch (err) { }
    }, 100);
  }
  onSearchDriverType(value: string) { }

  /** On vehicle select */
  onVehicleSelect(vehicle: any, close: any = null) {
    this.vehicle = {};
    if (vehicle.Year && vehicle.MakeName) {
      if (this.vehicle.connectedVia !== 'vin') {
        this.vehicle.vin = '';
      }
      this.errors.vehicle = '';
      this.vehicle = {
        ...this.vehicle,
        ...this.helperService.setVehicleConnectedMotorData(vehicle, this.searchType, this.vehicleQuery),
      };
      this.vehicle.vehicleName = this.vehicle.name;
      this.vehicle.vehicle = this.vehicle.vehicleName;
    }
    this.apiResponse = vehicle;
    this.selectVehicle = this.helperService.trimString((this.vehicle.title = `${this.vehicle.year || ''} ${this.vehicle.make || ''} ${this.vehicle.model || ''}`));
    (this.errors.year = ''), (this.errors.make = ''), (this.errors.model = '');
    this.errors.selectVehicle = '';
    this.isCreateVehicleMode = true;
    this.focus.vehicle = false;
    if (close) close();
  }
  openCreateVehicle() {
    if (this.vehicle.vehicle) {
      let splitVehicleName = this.vehicle.vehicle.split(' ');
      this.vehicle.year = splitVehicleName && splitVehicleName[0];
      this.vehicle.make = splitVehicleName && splitVehicleName[1];
      this.vehicle.model = this.vehicle.vehicle.split(`${splitVehicleName[0]} ${splitVehicleName[1]}`)[1];
      this.selectVehicle = this.helperService.trimString((this.vehicle.title = `${this.vehicle.year || ''} ${this.vehicle.make || ''} ${this.vehicle.model || ''}`));
      this.isCreateVehicleMode = true;
      this.focus.vehicle = false;
    } else {
      this.isCreateVehicleMode = true;
      this.focus.vehicle = false;
    }
  }

  handleChangeName(type: string, value: string | boolean) {
    this.userInfo[type] = value;
    this.errors[type] = '';
    this.formNotValid = false;
    if (type == 'firstName' && !this.userInfo.firstName) {
      this.errors.firstName = 'First Name required';
      this.formNotValid = true;
    } else if (type == 'lastName' && !this.userInfo.lastName) {
      this.errors.lastName = 'Last Name required';
      this.formNotValid = true;
    } else if (type == 'phone' && !this.userInfo.phone) {
      this.errors.phone = 'Mobile number required';
      this.formNotValid = true;
    } else if (type == 'phone' && typeof value === 'string' && value.length < 14) {
      this.errors.phone = `Phone is not valid`;
      this.formNotValid = true;
    } else if (type === 'email' && value) {
      this.userInfo.email = this.userInfo.email.trim();
      if (!this.validationEmailService.validateEmail(this.userInfo.email)) {
        this.errors.email = 'Email is not valid';
        this.formNotValid = true;
      }
    } else if (type === 'isMarketingNotifEnabled') {
      this.isMarketingNotifEnabled = value === true || value === 'true';
    } else if (type === 'isOperationalNotifEnabled') {
      this.isOperationalNotifEnabled = value === true || value === 'true';
    }

  }

  handleChangeDropOff(value) {
    this.userInfo.vehicleDropoff = value;
    this.errors.dropOff = '';
  }

  handleCheckboxChange(categoryIndex?: string, serviceIndex?: string, service?: any, value?: string) {
    this.selectedService = [];
    const serviceName = [];
    this.serviceCategories[categoryIndex].services[serviceIndex].isHidden = value;

    this.serviceCategories.forEach(category => {
      category.services.forEach(service => {
        if (service.isHidden && !this.selectedService.find(res => res === category.name)) {
          this.selectedService.push(category.name);
          this.errors.serviceValidation = ''
        }
        if (service.isHidden) {
          serviceName.push(service.name);
        }
      });
    });

    this.showServiceName = [...serviceName];
  }

  handleBlur(type: string) {
    this.focus[type] = false;
  }

  /** Getting data from the autocomplete input */
  handleChange(type: string, value: string) {
    this.vehicle[type] = value.trim();
    this.query[type] = value.trim();
    this.vehicle.title = this.helperService.trimString((this.vehicle.title = `${this.vehicle.year || ''} ${this.vehicle.make || ''} ${this.vehicle.model || ''}`));
    this.selectVehicle = this.vehicle.title;

    if (type === 'year' && !this.vehicle.year) {
      this.errors.year = 'Year required';
    }

    if (type === 'make' && !this.vehicle.make) {
      this.errors.make = 'Make required';
    }

    if (type === 'model' && !this.vehicle.model) {
      this.errors.model = 'Model required';
    }

    if (value) {
      this.errors[type] = '';
      this.errors.selectVehicle = '';
    }
  }

  /** Clear search suggestion */
  onSuggestionsClear(type: string) {
    if (type === 'vehicle') {
      this.vehicleSuggestions = [];
      this.vehicleType.active = []
      this.vehicleType.inactive = []

      this.vehicle.year = '';
      this.vehicle.make = '';
      this.vehicle.model = '';
      this.vehicle.title = '';
      this.selectVehicle = '';
    }
    this.query[type] = '';
  }

  handleFocus(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';
  }

  /** On vehicle search */
  onSearchVehicle(query: string) {
    this.vehicleQuery = query;
    this.isLoading = true;
    this.isVehicleSearchTriggered = true; // ✅ set search triggered
    this.vehicleType = { active: [], inactive: [] };
    this.httpService.searchMotorVehicleEndCustomerRequest(this.token, query.toLowerCase(), this.vehicle.registrationStateCode || this.defaultRegStateCode).then(
      (result: any) => {
        if (!result) {
          return;
        }

        this.vehicleSuggestions = [...result.Vehicles.map((vehicle: any) => this.helperService.setVehicleMotorSearchResults(vehicle, this.vehicleQuery))];

        this.vehicleSuggestions = sortBy(this.vehicleSuggestions, 'name');

        this.vehicleSuggestions.map((val) => {
          // if (val.VehicleIsActive) {
          this.vehicleType.active.push(val);
          // } else {
          //   this.vehicleType.inactive.push(val);
          // }
        });
        this.searchType = result.SearchType;
        this.isLoading = false;
        this.scrollToBottom();
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  validationConfirmRequest(): boolean {
    let isValid = true;

    if (this.customerDetails?.isVehicleMandatory) {
      if (!this.vehicle?.year || !this.vehicle?.make || !this.vehicle?.model) {
        if (!this.isCreateVehicleMode) {
          this.errors.selectVehicle = 'Please Select vehicle';
        }
        isValid = false;
      }
    }

    if (!this.nameValidation() || this.formNotValid) {
      return;
    }

    return isValid;
  }

  onConfirmRequest() {
    if (!this.validationConfirmRequest()) {
      return;
    }
    this.thirdStepper = false;
    this.fourthStepper = true;
    let categories = [];
    this.serviceCategories &&
      this.serviceCategories.map((category) => {
        let service = [];
        category.services.map((y) => {
          if (y.isHidden) {
            service.push({
              name: y.name,
              _id: y._id,
              isHidden: false,
            });
          }
        });
        if (service && service.length > 0) {
          categories.push({ name: category.name, _id: category._id, services: service, isHidden: false });
        }
      });
    let vehicle = {};
    if (this.vehicle && this.vehicle.year) {
      vehicle = {
        name: this.selectVehicle ? this.selectVehicle : '',
      };
    }
    let dateFormat: any = new Date(new Date(this.userInfo.selectedDay.day).setHours(this.userInfo.selectedDay.day.getHours() + this.userInfo.selectedTime.value));
    this.confirmedDate = dateFormat;
    dateFormat = this.dateService.formatDate(dateFormat, datetimeFormat.yyymmddhhmm);
    let payload: any = {
      description: this.userInfo.notes,
      color: '',
      code: '',
      isVehicleDropOff: this.customerDetails?.isVehicleDropOffVisible ? (this.userInfo.vehicleDropoff == this.dropOffs[0] ? false : true) : false,
      startDateTime: dateFormat,
      customer: {
        firstName: this.userInfo.firstName,
        lastName: this.userInfo.lastName,
        phone: this.helperService.removePhoneFormatting(this.userInfo.phone),
        email: this.userInfo.email,
      },
      vehicle: vehicle,
      serviceCategories: categories,
      isMarketingNotifEnabled: this.isMarketingNotifEnabled,
      isOperationalNotifEnabled: this.isOperationalNotifEnabled,
    };
    // Don't remove this condition as it's being used for google conversion tracking
    if (this.googleConversionTrackingToken) {
      payload.googleConversionTrackingToken = this.googleConversionTrackingToken;
    }
    // if(this.dataService.isMarketingEnabled && this.dataService.isMarketingLeadAttributionEnabled){
    if (this.campaign?.campaignType === 'LEAD') {
      payload.leadCampaign = {
        leadCampaignId: this.campaign._id,
        title: this.campaign.title,
        category: this.campaign.category,
      };
      if (this.googleConversionTrackingToken) {
        payload.leadCampaign.isGoBLeadCampaign = true;
        // payload.googleConversionTrackingToken = this.googleConversionTrackingToken;
      }
    } else if (this.campaign?.campaignType === 'FOLLOWUP') {
      payload.followUpCampaign = {
        campaignId: this.campaign._id,
        title: this.campaign.title,
        type: this.campaign.type,
      };
    } else if (this.campaign?.campaignType === 'PROMOTIONAL') {
      payload.marketingCampaign = {
        marketingCampaignId: this.campaign._id,
        title: this.campaign.title,
        type: this.campaign.type,
      };
    }

    // }
    this.httpService.createAppointmentRequest(this.token, payload).then((x) => {
      // if(this.campaign.isGoBLeadCampaign)
      this.googleBookCustomEvent(payload);
      this.helperService.showToaster('success', 'Request Created');
      this.code = x.code;
    });
  }

  googleBookCustomEvent(data) {
    if (this.companySetting.appsettings?.isGainSightPXEnabled) {
      const googleBookEventAdded: any = {
        customerName: `${data.customer.firstName} ${data.customer.lastName}`,
        customerPhoneNumber: data.customer?.phone || '',
        scheduledDateTime: data.startDateTime,
        services: this.getServiceNames(data.serviceCategories),
      };

      (<any>window).aptrinsic('track', 'Appointment Request', googleBookEventAdded);
    }
  }

  getServiceNames(serviceCategories) {
    let serviceNames = '';
    if (serviceCategories?.length) {
      serviceCategories.forEach(category => {
        if (category.services?.length) {
          category.services.forEach(item => {
            if (item.name) {
              serviceNames += !serviceNames ? `${item.name}` : `, ${item.name}`;
            }
          });
        }
      });
    }
    return serviceNames;
  }

  onNextStepper() {
    // if (this.secondStepper) {
    //   if (!this.nameValidation() || this.formNotValid) {
    //     return;
    //   } else {
    //     this.thirdStepper = true;
    //     this.secondStepper = false;
    //   }
    // }
    if (this.secondStepper) {
      if (!this.dayValidation()) {
        return;
      }
      else {
        this.thirdStepper = true;
        this.secondStepper = false;
      }
    }

    if (this.firstStepper) {
      this.errors.serviceValidation = '';
      if (this.selectedService && this.selectedService.length === 0) {
        this.errors.serviceValidation = 'Service required'
        return;
      }
      this.secondStepper = true;
      this.firstStepper = false;
      this.onDaySelect(this.userInfo.selectedDay, true);
    }
  }

  onBackStepper() {
    if (this.secondStepper) {
      this.secondStepper = false;
      this.firstStepper = true;
      this.onDaySelect(this.userInfo.selectedDay, true);
    }
    if (this.thirdStepper) {
      this.secondStepper = true;
      this.thirdStepper = false;
    }
  }

  sliderClass() {
    if (this.firstStepper) return 'width-25';
    if (this.secondStepper) return 'width-50';
  }

  clearSelectedDay() {
    this.selectedDay = [];
    this.selectedTimeCategory = [];
    this.selectedTimeSlot = [];
  }

  onDaySelect(day, state?, isClick?) {
    if (!day?.isDisable) return;

    if (!state) {
      this.isSaveState = false;
      this.clearSelectedDay();
      this.selectedDay.push(day.id);
      this.availableDates = [];

      const values: any = Object.values(day.companyHrs);
      values.forEach((x) => {
        this.time.forEach((y) => {
          if (y.day === 'morning') this.availableDates.push({ name: 'Morning', hrs: x.morning });
          if (y.day === 'evening') this.availableDates.push({ name: 'Evening', hrs: x.evening });
          if (y.day === 'midDay') this.availableDates.push({ name: 'Mid-day', hrs: x.midDay });
        });
      });

      if (isClick) {
        const defaultTime = this.availableDates.find((x) => x.hrs && x.hrs.length > 0);
        if (defaultTime) this.onTimeCategorySelect(defaultTime);
      }

      this.userInfo.selectedDay = day;
      this.errors.selectTime = '';
      this.errors.selectDay = '';
    } else {
      this.isSaveState = true;
    }
  }

  onTimeCategorySelect(time) {
    this.errors.selectTime = '';
    this.timeSlot = [];
    this.selectedTimeCategory = [];
    this.selectedTimeCategory.push(time.name);
    time.hrs.map((x) => {
      timeValue.forEach((y) => {
        if (x === y.value) {
          //for resetting time hours
          this.daysOfWeek[this.selectedDay[0]].day.setHours(0, 0, 0, 0);
          const day = this.daysOfWeek[this.selectedDay[0]].day;
          const selectedDay = day.setHours(day.getHours() + y.value);
          const serverTime = new Date(this.serverTime).getTime();
          const currentDateTimeTz = this.dateService.getCurrentDateTimeTz(serverTime).getTime();
          if (currentDateTimeTz < selectedDay) {
            this.timeSlot.push(y);
          }
        }
      });
    });

    if (this.timeSlot.length > 0 && this.selectedTimeSlot.length === 0) {
      this.onTimeSlotSelect(this.timeSlot[0]);
    }
  }

  onTimeSlotSelect(time) {
    this.selectedTimeSlot = [];
    this.selectedTimeSlot.push(time.value);
    this.userInfo.selectedTime = time;
    this.errors.selectTime = '';
  }

  // handleDateChange(date) {
  //   if (!this.isSaveState) {
  //     this.target.nativeElement.scrollLeft = 0;
  //     this.daysOfWeek = [];
  //     this.clearSelectedDay();
  //     let dateCheck: any;
  //     dateCheck = new Date(this.dateService.madeDateStringIOSCompatible(date.startDate));
  //     for (let i = 1; i <= 7; i++) {
  //       let clockDate: any = new Date(dateCheck.toDateString());
  //       clockDate = new Date(clockDate.setDate(clockDate.getDate()));
  //       this.daysOfWeek.push({
  //         day: clockDate,
  //         isDisable: true,
  //       });
  //       dateCheck = new Date(dateCheck.setDate(dateCheck.getDate() + 1));
  //     }
  //     this.startDate = this.dateService.formatDate(this.daysOfWeek[0].day, datetimeFormat.yyymmdd);
  //     this.endDate = this.dateService.formatDate(this.daysOfWeek[this.daysOfWeek.length - 1].day, datetimeFormat.yyymmdd);

  //     this.getCustomerRequest();
  //   }
  //   this.isSaveState = false;
  // }

  async handleDateChange(date) {
    if (!this.isSaveState) {
      this.target.nativeElement.scrollLeft = 0;
      this.daysOfWeek = [];
      this.clearSelectedDay();

      const dateCheck = new Date(this.dateService.madeDateStringIOSCompatible(date.startDate));
      for (let i = 0; i < 7; i++) {
        const clockDate = new Date(dateCheck.toDateString());
        this.daysOfWeek.push({ day: clockDate, isDisable: true });
        dateCheck.setDate(dateCheck.getDate() + 1);
      }

      this.startDate = moment(this.daysOfWeek[0].day).format('YYYY-MM-DD');
      this.endDate = moment(this.daysOfWeek[6].day).format('YYYY-MM-DD');

      await this.getCustomerRequest();

      const firstActiveDay = this.daysOfWeek.find(day => day.isDisable === true);
      if (firstActiveDay) {
        this.clearSelectedDay(); // Clear previous selection
        this.userInfo.selectedDay = firstActiveDay;
        const index = this.daysOfWeek.findIndex(d =>
          d.day.toDateString() === firstActiveDay.day.toDateString()
        );
        this.selectedDay.push(index); // use the index for visual highlighting

        this.onDaySelect(firstActiveDay, null, true);

        await this.waitForDayBoxes(); // Ensure view is ready before scroll

        const el = this.dayBoxes?.toArray()[index];
        if (el && this.target?.nativeElement) {
          const offset = el.nativeElement.offsetLeft;
          this.target.nativeElement.scrollTo({
            left: offset > 16 ? offset - 16 : offset,
            behavior: 'smooth',
          });
        }
      }
    }

    this.isSaveState = false;
  }


  async findAndLoadActiveWeek() {
    let attempts = 0;
    const maxAttempts = 10;
    let currentStart = moment().startOf('isoWeek');
    let currentEnd = moment().endOf('isoWeek');

    this.isFindingActiveWeek = true;

    while (attempts < maxAttempts) {
      this.startDate = currentStart.format('YYYY-MM-DD');
      this.endDate = currentEnd.format('YYYY-MM-DD');

      await this.getCustomerRequest();

      const activeDay = this.company?.find(d => d.isDayActive);
      if (activeDay) {
        const payload = {
          startDate: this.startDate,
          endDate: this.endDate,
          period: 'week'
        };

        this.defaultStartDate = currentStart.toDate(); // For <app-date-filter>
        await this.handleDateChange(payload);

        this.isFindingActiveWeek = false;
        return; // ✅ Exit loop once successful
      }

      await this.sleep(300); // Slight delay to avoid hammering API
      currentStart = currentStart.add(1, 'week');
      currentEnd = currentEnd.add(1, 'week');
      attempts++;
    }

    this.isFindingActiveWeek = false;
    console.warn('No active week found after max attempts');
  }


  sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private waitForDayBoxes(): Promise<void> {
    return new Promise((resolve) => {
      const checkReady = () => {
        const boxesReady = this.dayBoxes?.length === this.daysOfWeek.length;
        if (boxesReady) resolve();
        else setTimeout(checkReady, 50);
      };
      checkReady();
    });
  }


  defaultSettings() {
    let defaultDate = this.daysOfWeek.filter((x) => x.isDisable);
    if (defaultDate && defaultDate.length > 0) {
      this.isDirty = true;
      this.onDaySelect(defaultDate[0]);

      let defaultTime = this.availableDates.filter((x) => x.hrs && x.hrs.length > 0);
      if (defaultTime && defaultTime.length > 0) {
        this.onTimeCategorySelect(defaultTime[0]);
      }
    }
    this.isFirstTimeLoad = true;
  }

  checkDateAvailability() {
    this.updateDateStatus(this.company);
    this.daysOfWeek.map((x, i) => {
      x.availableDay = this.dateService.formatDate(x.day, datetimeFormat.yyymmdd);
      this.company &&
        this.company.length > 0 &&
        this.company.forEach((company) => {
          let companyHrs = [];
          companyHrs.push(company.officeHours);
          if (x.availableDay === company.date) {
            x.id = i;
            x.isDisable = company.isDayActive;
            x.companyHrs = companyHrs;
          }
        });
    });
  }

  scroll(el: HTMLElement, isLeft?) {
    if (isLeft) {
      // right scroll presses

      let dateCheck: any = this.helperService.deepCopy(this.daysOfWeek[this.daysOfWeek.length - 1].day);
      dateCheck = new Date(dateCheck);
      for (let i = 1; i <= 3; i++) {
        dateCheck = new Date(dateCheck.setDate(dateCheck.getDate() + 1));
        let clockDate: any = new Date(dateCheck.toDateString());
        clockDate = new Date(clockDate.setDate(clockDate.getDate()));
        this.daysOfWeek.push({
          day: clockDate,
          isDisable: false,
        });
      }
      this.startDate = this.dateService.formatDate(this.daysOfWeek[0].day, datetimeFormat.yyymmdd);
      this.endDate = this.dateService.formatDate(this.daysOfWeek[this.daysOfWeek.length - 1].day, datetimeFormat.yyymmdd);

      this.getCustomerRequest();
      el.scrollLeft = el.scrollLeft + 284;
    } else {
      // left scroll presses

      let dateCheck: any = this.helperService.deepCopy(this.daysOfWeek[0].day);
      let newDate: any = new Date();

      dateCheck = new Date(dateCheck);
      this.helperService.formatPhoneNumber('sadsa');
      dateCheck = new Date(dateCheck.setDate(dateCheck.getDate() - 1));

      el.scrollLeft = el.scrollLeft + 284;
      for (let i = 1; i <= 3; i++) {
        if (Date.parse(newDate) < Date.parse(dateCheck)) {
          let clockDate: any = new Date(dateCheck.toDateString());
          clockDate = new Date(clockDate.setDate(clockDate.getDate()));
          this.daysOfWeek.unshift({
            day: clockDate,
            isDisable: false,
          });
          dateCheck = new Date(dateCheck.setDate(dateCheck.getDate() - 1));
        } else {
          el.scrollLeft = el.scrollLeft - 284;
        }
      }
      this.startDate = this.dateService.formatDate(this.daysOfWeek[0].day, datetimeFormat.yyymmdd);
      this.endDate = this.dateService.formatDate(this.daysOfWeek[this.daysOfWeek.length - 1].day, datetimeFormat.yyymmdd);
      if (Date.parse(newDate) > Date.parse(dateCheck)) {
        if (el.scrollLeft < 250) {
          el.scrollLeft = el.scrollLeft - 284;
        } else {
          el.scrollLeft = el.scrollLeft - 100;
        }
      }
    }
  }
  onScroll(event: any) {
    if (event.srcElement.scrollLeft % 180 == 0 && event.srcElement.scrollLeft > 1) {
      this.scroll(event.target, true);
    }
  }

  updateShopLevelColor(response) {
    this.companyLogo = response.company.logo;
    this.primaryColor = response?.company?.appsettings?.apptRequestPortal?.themeColor || '#00C19D';
    this.bgColor = this.helperService.applyOpacity(this.primaryColor, 0.08);
    document.documentElement.style.setProperty('--primary-500', this.primaryColor);
    document.documentElement.style.setProperty('--primary-200', this.bgColor);
  }

  updateDateStatus(dates) {
    let today: any = new Date();
    today.setHours(0, 0, 0, 0);
    dates.forEach(dateObj => {
      //For JS always use the standard date format befor converting it to date object i.e. Month-Day-Year otherwise we will the get one day off date
      let date: any = new Date(this.dateService.get(datetimeFormat.mmddyyyy, dateObj.date));
      date.setHours(0, 0, 0, 0);

      let diffInTime = date - today;
      let diffInDays = diffInTime / (1000 * 3600 * 24);

      if (dateObj.isDayActive) {
        if (diffInDays < this.dayStart) {
          dateObj.isDayActive = false;
        } else {
          dateObj.isDayActive = true;
        }
      }
    });
  }
}
